var _circle, _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 239,
    viewBox: "0 0 239 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 119.5,
    cy: 119.5,
    r: 115.5,
    fill: "black",
    stroke: "white",
    strokeWidth: 8
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_665_731",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239 119.5C239 139.452 234.004 159.086 224.469 176.612C214.934 194.137 201.162 208.997 184.41 219.834C167.658 230.672 148.46 237.142 128.565 238.656C108.671 240.169 88.7143 236.677 70.5158 228.499C52.3172 220.321 36.456 207.716 24.3791 191.834C12.3021 175.953 4.39372 157.3 1.37537 137.578C-1.64298 117.856 0.324764 97.692 7.0991 78.9255C13.8734 60.159 25.2387 43.3873 40.1583 30.1404L45.5215 36.1808C31.6104 48.5323 21.0134 64.1703 14.697 81.6682C8.38057 99.1662 6.54584 117.967 9.36016 136.356C12.1745 154.745 19.5483 172.137 30.8089 186.945C42.0695 201.753 56.8585 213.506 73.8269 221.131C90.7953 228.757 109.403 232.012 127.952 230.601C146.502 229.19 164.403 223.157 180.022 213.052C195.642 202.947 208.483 189.092 217.374 172.751C226.264 156.41 230.922 138.103 230.922 119.5H239Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239 119.5C239 139.452 234.004 159.086 224.469 176.612C214.934 194.137 201.162 208.997 184.41 219.834C167.658 230.672 148.46 237.142 128.565 238.656C108.671 240.169 88.7143 236.677 70.5158 228.499C52.3172 220.321 36.456 207.716 24.3791 191.834C12.3021 175.953 4.39372 157.3 1.37537 137.578C-1.64298 117.856 0.324764 97.692 7.0991 78.9255C13.8734 60.159 25.2387 43.3873 40.1583 30.1404L45.5215 36.1808C31.6104 48.5323 21.0134 64.1703 14.697 81.6682C8.38057 99.1662 6.54584 117.967 9.36016 136.356C12.1745 154.745 19.5483 172.137 30.8089 186.945C42.0695 201.753 56.8585 213.506 73.8269 221.131C90.7953 228.757 109.403 232.012 127.952 230.601C146.502 229.19 164.403 223.157 180.022 213.052C195.642 202.947 208.483 189.092 217.374 172.751C226.264 156.41 230.922 138.103 230.922 119.5H239Z",
    fill: "black",
    stroke: "#FFE236",
    strokeWidth: 12,
    mask: "url(#path-2-inside-1_665_731)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.dd566a825d8b2315058a1ef37200c5d9.svg";
export { ForwardRef as ReactComponent };